import { Component, HostBinding, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { OnlineStripImage } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-strip-image',
  templateUrl: './strip-image.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./strip-image.component.scss'],
})
export class StripImageComponent implements OnChanges {
  contentUrl = environment.cmsOrigin;

  @Input() content: OnlineStripImage;
  @HostBinding('style.--strip-bg-color') bgColor: string;
  @HostBinding('style.--strip-padding-left') leftPadding: string;
  @HostBinding('style.--strip-padding-right') rightPadding: string;
  @HostBinding('style.--strip-padding-top') topPadding: string;
  @HostBinding('style.--strip-padding-bottom') bottomPadding: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['content']) {
      this.bgColor = this.content.backgroundColor;
      this.leftPadding = `${this.content.leftPadding ?? 24}px`;
      this.rightPadding = `${this.content.rightPadding ?? 24}px`;
      this.topPadding = `${this.content.topPadding ?? 40}px`;
      this.bottomPadding = `${this.content.bottomPadding ?? 40}px`;
    }
  }
}
